import { Box, Button } from '@mui/material';
import { t } from 'i18next';
import { FontAwesomeSvgIcon } from 'components/shared';
import { faMagnifyingGlass } from 'vendors/@fortawesome/pro-light-svg-icons';

type SearchButtonProps = {
  onSearch: () => void;
  disabled?: boolean;
};

const SearchButton = ({ onSearch, disabled }: SearchButtonProps) => {
  return (
    <Box marginY={1} maxWidth={200}>
      <Button
        variant="contained"
        sx={{ width: 'fit-content' }}
        color="dark"
        disabled={disabled}
        onClick={() => {
          onSearch();
        }}
      >
        <FontAwesomeSvgIcon
          icon={faMagnifyingGlass}
          fontSize="small"
          sx={{ m: 'auto', mr: 1 }}
        />
        {t('search')}
      </Button>
    </Box>
  );
};

export default SearchButton;
